/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from '../utils/axios'

/*
    订单接口
*/
// 客户列表
export const getCustomerList = function (data: {
    customerName: string;
    limit: number;
}) {
    return axios.post('/finance/getCustomerList', data)
}

// 论文项目类型
export const getDissertationList = function () {
    return axios.get('/finance/getDissertationList')
}


// 项目列表
export const getProjectList = function (data: {
    marketCooperationId: number;
    name: string;
    souCourseSchoolBegin?: string;
    limit: number;
    page: number;
}) {
    return axios.post('/finance/getProjectList', data)
}

// 主项目列表
// export const getOrderCourseListByCustomerId = function(customerId: number,souCourseName: string) {
//     return axios.get('/finance/getOrderCourseListByCustomerId?customerId=' + customerId)
// }
export const getOrderCourseListByCustomerId = function (data: { customerId: number; souCourseName: string; customerType: string }) {
    return axios.get('/finance/getOrderCourseListByCustomerId', {params: data})
}

// 合作伙伴佣金类型(普通订单)
export const getMarketCooperationCommissionTypeByMarketCooperationIdAndProjectAllId = function (data: { marketCooperationId: number; projectAllId: number }) {
    return axios.post('/finance/getMarketCooperationCommissionTypeByMarketCooperationIdAndProjectAllId', data)
}
// 论文佣金类型
export const getDissertationIdCommissionType = function (data: {
    marketCooperationId: number;  //合作伙伴id
    projectDissertationId: number;   //论文项目id
}) {
    return axios.post('/finance/getMarketCooperationCommissionTypeByMarketCooperationIdAndProjectDissertationId', data)
}


// 提交订单/存草稿
export const setFinanceOrder = function (data: {
    customerId: number;
    sourceType: string;
    source: string;
    projectAllId: number;
    souCoursePrice: string;
    commissionType: string;
    priceOrRatio?: string;
    discountPrice?: string;
    haveIPQ: string;
    price: string;
    remark?: string;
    createdUserId: string;
    adviser: string;
    directorUserId: string;
    isDraft: string;
    marketCooperationId: number;
}) {
    return axios.post('/finance/setFinanceOrder', data)
}

// 订单编辑
export const setFinanceOrderById = function (data: {
    id: number;
    projectAllId: number;
    souCoursePrice: string;
    commissionType: string;
    priceOrRatio?: string;
    discountPrice?: string;
    haveIPQ: string;
    remark?: string;
    adviser: string;
    directorUserId: string;
    projectDissertationId: number;
    souCourseName: string;

}) {
    return axios.post('/finance/setFinanceOrderById', data)
}

// 订单列表
export const getFinanceOrderList = function (data: {
    customerName?: string;
    customerType?: string;
    caseStatus?: string;
    types?: string;
    status?: string;
    haveIPQ?: string;
    createdAt?: string;
    directorUserIdList?: string[];
    limit: number;
    page: number;
    souCourseTypeId?: number;
    souCourseSchoolBegin?: string;
    adviser?: string;
    finishAt?: string; //服务完成时间
    companyName?: string; //所属公司
}) {
    return axios.post('/finance/getFinanceOrderList', data)
}

// 订单详情
export const getFinanceOrderById = function (data: { id: number; isUpdatedData: string }) {
    return axios.get('/finance/getFinanceOrderById', {params: data})
}

// 导出订单列表
export const financeOrderExportData = function (data) {
    return axios.post('/finance/financeOrderExportData', data)
}
// 提交 撤回审批
export const setFinanceOrderStatus = function (data: {
    id: number;
    action: string;
}) {
    return axios.post('/finance/setFinanceOrderStatus', data)
}

// 删除订单
export const delFinanceOrderById = function (id: number) {
    return axios.delete('/finance/delFinanceOrderById', {data: {id}})
}

// 申请退项
export const financeOrderBowOutById = function (data: { id: number; reason: string }) {
    return axios.post('/finance/financeOrderBowOutById', data)
}

// 统计数据
export const getFinanceOrderStatisticalData = function (data: { types?: string; dissertationType?: string; createdAt?: string; souCourseName?: string; souCourseSchoolBegin: string;backMoneyStatusList: []; limit: number; page: number }) {
    return axios.post('/finance/getFinanceOrderStatisticalData', data)
}

// 统计数据导出
export const financeOrderStatisticalDataExport = function (data: { types?: string; dissertationType?: string; souCourseName?: string; souCourseSchoolBegin?: string; createdAt?: string; keys?: string }) {
    return axios.post('/finance/financeOrderStatisticalDataExport', data)
}


/*
* 订单-下载产出*/

export const getStudentOutputById = function (data: { id: string }) {
    return axios.get('/finance/getStudentOutputById', {params: data})
}


// 回款
/*
    @param {mainPart} 列表类型  0-学生，2-合作伙伴
    @parma {page} 页数
*/
// 客户/合作伙伴列表
export const getCustomerNameListByFinanceBackMoneyMainPart = function (data: any) {
    return axios.post('/finance/getCustomerNameListByFinanceBackMoneyMainPart', data)
}

// 获取订单列表
export const getFinanceOrderByCustomerIdOrMarketCooperationId = function (data: any) {
    return axios.post('/finance/getFinanceOrderByCustomerIdOrMarketCooperationId', data)
}

// export const getFinanceOrderByCustomerIdOrMarketCooperationId = function (data: { mainPart: string; customerId?: number; customerType?: string; marketCooperationId?: number; page: number; limit: number }) {
//     return axios.get('/finance/getFinanceOrderByCustomerIdOrMarketCooperationId', {params: data})
// }

// 新建回款
export const setFinanceBackMoney = function (data: {
    mainPart: string;
    customerId?: number;
    customerType?: string;
    marketCooperationId?: number;
    account: string;
    backMoneyAt: string;
    financeBackMoneyDetailList: { financeOrderId: number; thisTimePrice: string }[];
    financeBackMoneyProofList: { url: string; name: string }[];
    directorUserId: string;
    isDraft: string;
    remark?: string; //备注
}) {
    return axios.post('/finance/setFinanceBackMoney', data)
}

// 回款列表
export const getFinanceBackMoneyList = function (data: any) {
    return axios.post('/finance/getFinanceBackMoneyList', data)
}

// 回款详情
export const getFinanceBackMoneyById = function (data: { id: number; isUpdatedData: string }) {
    return axios.get('/finance/getFinanceBackMoneyById', {params: data})
}

// 获取流水号绑定回款总额
// @api {get} /finance/transactionNumberSum/:transactionNumber
export const getTransactionNumberSum = function (transactionNumber: string) {
    return axios.get(`/finance/transactionNumberSum/${transactionNumber}`)
}

// 编辑保存回款
export const setFinanceBackMoneyById = function (data: {
    id: number;
    account: string;
    backMoneyAt: string;
    financeBackMoneyDetailList: { financeOrderId: number; thisTimePrice: string }[];
    financeBackMoneyProofList: { url: string; name: string }[];
    directorUserId: string;
    remark?: string;
}) {
    return axios.post('/finance/setFinanceBackMoneyById', data)
}

// 提交、撤回审批（回款）
export const setFinanceBackMoneyStatus = function (data: { id: number; action: string }) {
    return axios.post('/finance/setFinanceBackMoneyStatus', data)
}

// 回款列表导出
export const financeBackMoneyExportData = function (data: { mainPart?: string; customerOrCooperationName?: string; createdAt?: string; status?: string; keys?: string }) {
    return axios.post('/finance/financeBackMoneyExportData', data) as any
}

// 回款详情导入模板
export const getFinanceBackMoneyDetailTemplate = function () {
    return axios.get('/finance/getFinanceBackMoneyDetailTemplate')
}

// 导入回款详情
export const importFinanceBackMoneyDetail = function (data: any) {
    return axios.post('/finance/importFinanceBackMoneyDetail', data)
}

// ========= 回款对账功能=========

// 上传对账文件
export const importFinanceBackMoneyReconcile = function (data: any) {
    return axios.post('/finance/reconcile', data)
}


// 获取回款的相关信息，从订单列表点击回款的时候跳转到新建回款页面调用的接口
export const getFinanceBackMoneyInfoById = function (data: { mainPart: string; id: number; isFrom?: string}) {
    return axios.get('/finance/getFinanceBackMoneyInfoById', {params: data})
}

// 删除回款
export const delFinanceBackMoneyById = function (id: number) {
    return axios.delete('/finance/delFinanceBackMoneyById', {data: {id}})
}
// 回款统计数据
export const financeBackMoneyStatisticalData = function (
    data: {
        souCourseName?: string;
        souCourseType?: string;
        souCourseSchoolBegin?: string;
        marketCooperationName?: string;
        marketCooperationTypes?: string;
        createdAt?: string;
        code?: string;
        financeOrderCode?: string;
        financeOrderCreatedUserIdList?: object[];
        customerDirectorUserIdList?: object[];
        createdUserIdList?: object[];
        dissertationType?: string;
        limit: number;
        page: number;
    }) {
    return axios.post('/finance/financeBackMoneyStatisticalData', data)
}

// 回款统计数据导出
export const financeBackMoneyStatisticalDataExport = function (
    data: {
        souCourseName?: string;
        souCourseType?: string;
        souCourseSchoolBegin?: string;
        marketCooperationName?: string;
        marketCooperationTypes?: string;
        createdAt?: string;
        code?: string;
        financeOrderCode?: string;
        financeOrderCreatedUserIdList?: object[];
        customerDirectorUserIdList?: object[];
        createdUserIdList?: object[];
        dissertationType?: string;
        keys?: string;
    }
) {
    return axios.post('/finance/financeBackMoneyStatisticalDataExport', data)
}


// 转退记录-订单
export const getFinanceOrderRecordList = function (data: {
    customerName: string;  //客户名称
    customerType: string; //客户类型 允许值: 'C端客户', 'B端客户'
    directorUserIdList: any; //负责人id
    types: string;  //变更类型 允许值: '换项目', '退项目'
    prevSouCourseName: string;  //变更前项目
    prevSouCourseSchoolBegin: string;  //变更前项目开课时间
    endSouCourseName: string;  //变更后项目
    endSouCourseSchoolBegin: string;   //变更后项目开课时间
    submitAt: string;  //提交时间
    approvedAt: string;   //通过时间
    limit: number;  //条数/页
    page: number; //页码
}) {
    return axios.post('/finance/getFinanceOrderRecordList', data)
}
// 转退记录导出
export const financeOrderRecordExportData = function (data: {
    customerName: string;
    customerType: string;
    directorUserIdList: any;
    types: string;
    prevSouCourseName: string;
    prevSouCourseSchoolBegin: string;
    endSouCourseName: string;
    endSouCourseSchoolBegin: string;
    submitAt: string;
    approvedAt: string;
    keys?: string;
}) {
    return axios.post('/finance/financeOrderRecordExportData', data)
}
// 合作伙伴列表
export const getFinanceOrderMarketCooperationList = function (data: { marketCooperationName: string; page: number; limit: number }) {
    return axios.get('/finance/getFinanceOrderMarketCooperationList', {params: data})
}
// 订单列表
export const getFinanceOrderByMarketCooperationId = function (
    data: {
        marketCooperationId: string;
        customerName: string;
        page: number;
        limit: number;
    }
) {
    return axios.post('/finance/getFinanceOrderByMarketCooperationId', data)
}

// 所属公司列表
export const getCompanyList = function (
    data?: {
        isContract: boolean;
    }) {
    return axios.get('/finance/getCompanyList', {params: data})
}

// 返佣列表
export const getFinanceCommissionList = function (data: {
    limit: number;  //条数/页
    page: number; //页码
    marketCooperationName: string;  //合作伙伴名称
    directorUserIdList: any; //负责人id
    status: string; //返佣状态  允许值: 0-审批中, 1-已通过, 2-未通过, 3-未提交, 4-已撤回
}) {
    return axios.post('/finance/getFinanceCommissionList', data)
}

// 返佣详情
export const getFinanceCommissionById = function (data: { id: number; isUpdatedData: string }) {
    return axios.get('/finance/getFinanceCommissionById', {params: data})
}
// 新建返佣
export const setFinanceCommission = function (data: {
    marketCooperationId: number;   //合作伙伴id
    isBackStudentContract: string;  //是否交回学生合同 允许值: '0-否', '1-是'
    isBackAgentContract: string;  //是否交回代理合同 允许值: '0-否', '1-是'
    financeCommissionDetailList: { financeOrderId: number; extraPrice: string }[]; //返佣详情
    financeCommissionProofList: { url: string; name: string }[]; //转款凭证
    directorUserId: any; //负责人id
    isDraft: string;  //具体操作 允许值: 0-提交, 1-存草稿
    remark?: string;//备注
    payeeInfoId?: string;//易快报收款账户id
}) {
    return axios.post('/finance/setFinanceCommission', data)
}
// 删除返佣订单
export const delFinanceCommissionById = function (id: number) {
    return axios.delete('/finance/delFinanceCommissionById', {data: {id}})
}
// 返佣导出
export const financeCommissionExportData = function (data: {
    marketCooperationName: string;  //合作伙伴名称
    directorUserIdList: any;  //负责人id
    status: string;  //返佣状态   允许值: 0-审批中, 1-已通过, 2-未通过, 3-未提交, 4-已撤回
    keys?: string;
}) {
    return axios.post('/finance/financeCommissionExportData', data)
}

/*同步返佣单据到易快报*/
export const syncFinanceCommissionToEkuaibao = function (data: {
    id: string;  // 返佣id
}) {
    return axios.post('/finance/syncFinanceCommissionToEkuaibao', data)
}


// 返佣提交审批、重新提交
export const setFinanceCommissionStatus = function (data: {
    id: number;  //返佣id
    action: string;  //允许值: 0-提交, 1-撤销
}) {
    return axios.post('/finance/setFinanceCommissionStatus', data)
}
// 编辑返佣
export const setFinanceCommissionById = function (data: {
    id: number;   //合作伙伴id
    // isBackStudentContract: string;  //是否交回学生合同 允许值: '0-否', '1-是'
    isBackAgentContract: string;  //是否交回代理合同 允许值: '0-否', '1-是'
    financeCommissionDetailList: { financeOrderId: number; extraPrice: string }[]; //返佣详情
    financeCommissionProofList: { url: string; name: string }[]; //转款凭证
    directorUserId: any; //负责人id
    remark?: string;//备注
}) {
    return axios.post('/finance/setFinanceCommissionById', data)
}
// 新增/修改打款信息（返佣） 2022-10-17
export const setFinanceCommissionAccountByFinanceCommissionId = function (data: {
    financeCommissionId: number;  //返佣id
    payeeInfoId: string;  //易快报收款账户id
}) {
    return axios.post('/finance/setFinanceCommissionAccountByFinanceCommissionId', data)
}
// 获取打款信息（返佣）
export const getFinanceCommissionAccountByFinanceCommissionId = function (data: { financeCommissionId: number }) {
    return axios.get('/finance/getFinanceCommissionAccountByFinanceCommissionId', {params: data})
}
// 返佣统计报表 2023/02/09
export const financeCommissionStatisticalData = function (data: {
    limit?: number;
    page?: number;
}) {
    return axios.post('/finance/financeCommissionStatisticalData', data)
}

// 返佣统计报表导出2023/02/09
export const financeCommissionStatisticalDataExport = function (data: {
    code: string;  //返佣编号
    financeOrderCode: string; //订单编号
    keys?: string;
}) {
    return axios.post('/finance/financeCommissionStatisticalDataExport', data)
}


/* 退款接口 */
// 退款订单列表
export const getFinanceOrderListByCustomerIdOrMarketCooperationId = function (data: {
    mainPart: string;
    customerId?: number;
    customerType?: string;
    marketCooperationId?: number;
    limit: number;
    page: number;
    customerName?: string;
}) {
    return axios.post('/finance/getFinanceOrderListByCustomerIdOrMarketCooperationId', data)
}

// 返佣新增收款信息
export const setPayeeInfo = function (data: {
    type: string;
    name: string;
    cardNum: string;
    branch: string;
}) {
    return axios.post('/ekuaibao/setPayeeInfo', data)
}

// 新建退款
export const setFinanceRefund = function (data: {
    types: string;
    mainPart: string;
    customerId?: number;
    customerType?: string;
    marketCooperationId?: number;
    account: string;
    financeOrderId: number;
    price: string;
    refundAt: string;
    refundCause: string;
    directorUserId: string;
    isDraft: string;
}) {
    return axios.post('/finance/setFinanceRefund', data)
}

// 退款列表
export const getFinanceRefundList = function (data: {
    mainPart?: string;
    mainPartName?: string;
    directorUserIdList?: string[];
    status?: string;
    refundAt?: string;
    limit: number;
    page: number;
}) {
    return axios.post('/finance/getFinanceRefundList', data) as unknown as { allNum: number; financeRefundList: any[] }
}

// 退款详情
export const getFinanceRefundById = function (data: { id: number; isUpdatedData?: string }) {
    return axios.get('/finance/getFinanceRefundById', {params: data})
}

/*同步退款单据到易快报*/
export const syncFinanceRefundToEkuaibao = function (data: {
    id: string;  //退款id
}) {
    return axios.post('/finance/syncFinanceRefundToEkuaibao', data)
}

// 编辑退款
export const setFinanceRefundById = function (data: {
    id: number;
    account: string;
    price: string;
    refundAt: string;
    refundCause: string;
    directorUserId: string;
}) {
    return axios.post('/finance/setFinanceRefundById', data)
}

// 提交、撤回审批
export const setFinanceRefundStatus = function (data: { id: number; action: string }) {
    return axios.post('/finance/setFinanceRefundStatus', data)
}

// 删除退款
export const delFinanceRefundById = function (id: number) {
    return axios.delete('/finance/delFinanceRefundById', {data: {id}})
}

// 退款导出
export const financeRefundExportData = function (data: {
    mainPart?: string;
    mainPartName?: string;
    directorUserIdList?: string[];
    status?: string;
    refundAt?: string;
    keys?: string;
}) {
    return axios.post('/finance/financeRefundExportData', data)
}
// 退款统计数据
export const financeRefundStatisticalData = function (data: { dissertationType?: string; souCourseName?: string; souCourseSchoolBegin: string; limit: number; page: number }) {
    return axios.post('/finance/financeRefundStatisticalData', data)
}

// 退款统计数据导出
export const financeRefundStatisticalDataExport = function (
    data: {
        customerName: string;
        marketCooperationName: string;
        souCourseName: string;
        refundCause: string;
        souCourseTypeIdList: object;
        keys?: string;
    }
) {
    return axios.post('/finance/financeRefundStatisticalDataExport',  data)
}

/*回款凭证（退款）
* /finance/getFinanceBackMoneyProofByFinanceRefundId*/
export const getFinanceBackMoneyProofByFinanceRefundId = function (data: { financeRefundId: string }) {
    return axios.get('/finance/getFinanceBackMoneyProofByFinanceRefundId', {params: data})
}



// 订单/回款列表（开票）
export const getOrderListOrMarketCoopetationId = function (data: {
    mainPart: string;   //开票主体 允许值: 0-学生, 1-合作伙伴
    page: number;
    limit: number;
    basis: string;   //开票依据 允许值: 0-订单编号, 1-回款编号
    customerId: number;  //客户id // 当mainPart = 0时必需
    customerType: string;   //客户类型 // 当mainPart = 0时必需 允许值: 'customerConversion-转化客户', 'customerBusiness-B端客户'
    marketCooperationId: number;   //合作伙伴id // 当mainPart = 1时必需
    code: string;   //订单/回款编号
    customerName: string;   //    客户名称
}) {
    return axios.post('/finance/getOrderListOrBackMoneyListByCustomerIdOrMarketCoopetationId', data)
}

// 开票列表
export const getFinanceInvoiceList = function (data: {
    mainPart: string;  //开票主体 允许值: 0-学生, 1-合作伙伴
    mainPartName: string;  //主体名称
    limit: number;  //条数/页
    page: number; //页码
    createdAt: string;  //提交时间
    invoiceAt?: string;  //财务开票时间 // 2022-08-04
    directorUserIdList: any; //负责人id
    status: string; //开票状态  允许值: 0-审批中, 1-已通过, 2-未通过, 3-未提交, 4-已撤回
}) {
    return axios.post('/finance/getFinanceInvoiceList', data)
}


/*
* 作废开票
* financeInvoiceDetailList: 作废明细 对象数组 [{ financeOrderId, price }]，price 为作废金额
* */
export const updFinanceInvoiceById = function (data: {
    id: number;
    financeInvoiceDetailList: object[];
}) {
    return axios.post('/finance/updFinanceInvoiceById',  data)
}


// 新建列表
export const setFinanceInvoice = function (data: {
    mainPart: string;  //开票主体 允许值: 0-学生, 1-合作伙伴
    customerId: number;  //客户id // 当mainPart = 0时必需
    customerType: string;  //客户类型 // 当mainPart = 0时必需  允许值: 'customerConversion-转化客户', 'customerBusiness-B端客户'
    marketCooperationId: number;  //合作伙伴id 当mainPart = 1时必需
    basis: string;  //开票依据 允许值: 0-订单编号, 1-回款编号
    code: string;  //订单/回款编号
    account: string;  //收款账户 允许值: '苏州', '北京', '广州', '上海'
    isProof: string;  //是否生成凭证   允许值: 0-否, 1-是
    remark: string;  //备注
    invoiceType: string;  //开票类型 允许值: 0-增值税专用票, 1-普通发票
    invoiceTitle: string;  //开票抬头 当mainPart = 0时必需
    invoiceCode: string;  //纳税识别号 当mainPart = 0时必需
    invoiceBank: string;  //开户行 当mainPart = 0时必需
    invoiceAccount: string;  //开户账号 当mainPart = 0时必需
    invoiceAddress: string;  //开票地址  当mainPart = 0时必需
    invoicePhone: string;  //电话 当mainPart = 0时必需
    directorUserId: string; //负责人id
    invoiceContent: string; //开票内容 09-16
    financeInvoiceDetailList: { financeOrderId: number; thisTimePrice: string }[]; //开票详情  订单id  本次开票金额
}) {
    return axios.post('/finance/setFinanceInvoice', data)
}


/*开票回款
* /finance/getFinanceBackMoneyDetailByFinanceInvoiceId
* */

export const getFinanceBackMoneyDetailByFinanceInvoiceId = function (data: { financeInvoiceId: string }) {
    return axios.get('/finance/getFinanceBackMoneyDetailByFinanceInvoiceId', {params: data})
}

// 开票详情
export const getFinanceInvoiceById = function (data: { id: number; isUpdatedData: string }) {
    return axios.get('/finance/getFinanceInvoiceById', {params: data})
}
// 删除开票
export const delFinanceInvoiceById = function (id: number) {
    return axios.delete('/finance/delFinanceInvoiceById', {data: {id}})
}
// 导出开票
export const financeInvoiceExportData = function (data) {
    return axios.post('/finance/financeInvoiceExportData', data)
}
// 提交撤销审批开票
export const setFinanceInvoiceStatus = function (data: {
    id: number;
    action: string;  //0-提交, 1-撤销
}) {
    return axios.post('/finance/setFinanceInvoiceStatus', data)
}

// 编辑保存开票
export const setFinanceInvoiceById = function (data: {
    id: number;
    account: string;  //收款账户 允许值: '苏州', '北京', '广州', '上海'
    isProof: string;  //是否生成凭证   允许值: 0-否, 1-是
    remark: string;  //备注
    financeInvoiceDetailList: { financeOrderId: number; thisTimePrice: string }[]; //开票详情  订单id  本次开票金额
    directorUserId: string; //负责人id
    // 可选
    invoiceType: string;  //开票类型 允许值: 0-增值税专用票, 1-普通发票
    invoiceTitle: string;  //开票抬头 当mainPart = 0时必需
    invoiceCode: string;  //纳税识别号 当mainPart = 0时必需
    invoiceBank: string;  //开户行 当mainPart = 0时必需
    invoiceAccount: string;  //开户账号 当mainPart = 0时必需
    invoiceAddress: string;  //开票地址  当mainPart = 0时必需
    invoicePhone: string;  //电话 当mainPart = 0时必需
    invoiceContent: string;  //开票内容
    invoiceAt?: string;  //财务开票时间 2022-08-04
}) {
    return axios.post('/finance/setFinanceInvoiceById', data)
}
// 获取开票详情导入模板
export const getFinanceInvoiceDetailTemplate = function () {
    return axios.get('/finance/getFinanceInvoiceDetailTemplate')
}
// 导入开票详情
export const importFinanceInvoiceDetail = function (data: any) {
    return axios.post('/finance/importFinanceInvoiceDetail', data)
}

// 获取开票内容
export const getFinanceInvoiceContent = function (data: {
    companyName: string;
}) {
    return axios.get('/finance/getFinanceInvoiceContent',{params:data})
}

// 归档列表
export const getFinanceArchiveList = function (data: {
    customerName: string;  //开票主体 客户名称
    souCourseName: string;  //项目名称
    sourceType: string; //来源 允许值: '0-合作伙伴', '1-市场渠道', '2-其他'
    limit: number;  //条数/页
    page: number; //页码
    souCourseSchoolBegin: string;  //项目开课时间
    createdAt: string;  //订单创建时间
    directorUserIdList: any; //负责人id
    createdUserId: string; //订单创建人
    financeOrderPrice: string;  //订单金额
    financeOrderCode: string;  //订单编号
    // financeBackMoneyCreatedAt: string;  //回款创建时间
}) {
    return axios.post('/finance/getFinanceArchiveList', data)
}

// 导出归档
export const financeArchiveExportData = function (data) {
    return axios.post('/finance/financeArchiveExportData', data)
}
// 获取各等级部门

// export const getDepartmentByLevel = function (data: { customerId: number; souCourseName: string }) {
//     return axios.get('/user/getDepartmentByLevel', { params: data })
// }
export const getDepartmentByLevel = function (level: string) {
    return axios.get('/user/getDepartmentByLevel', {params: {level}})
}

// 转案
export const setFinanceOrderCaseStatusById = function (data) {
    return axios.post('/finance/setFinanceOrderCaseStatusById', data)
}


// 批量转案
export const setFinanceOrderCaseStatusByIdList = function (
    data: { idList: any }
) {
    return axios.post('/finance/setFinanceOrderCaseStatusByIdList', data)
}
// 归档统计报表部门列表
export const financeArchiveStatisticalDataDepartmentList = function () {
    return axios.get('/finance/financeArchiveStatisticalDataDepartmentList')
}
// 归档统计报表
export const financeArchiveStatisticalData = function (data: {
    departmentId?: number;
    timeStr: string;
    timeStrSecond?: string;
}) {
    return axios.post('/finance/financeArchiveStatisticalData', data)
}
// 归档统计报表设置业绩任务
export const setFinanceAchievementTask = function (data: {
    departmentIdOrUserIdList: string[];
    taskVolume: number;
    customerNumber: number;
}) {
    return axios.post('/finance/setFinanceAchievementTask', data)
}

// 市场费用列表
export const getFinanceMarketCost = function (data: {
    types: string;  // 费用类型
    directorUserIdList: object[];  // 负责人id
    code: '';  // 市场费用编号
    status: '';  // 费用类型
    createdAt: '';  // 创建时间
    limit: number;  //条数/页
    page: number; //页码
}) {
    return axios.post('/finance/getFinanceMarketCostList', data)
}

/*同步市场费用单据到易快报*/
export const syncFinanceMarketCostToEkuaibao = function (data: {
    id: string;  // 市场费用id
}) {
    return axios.post('/finance/syncFinanceMarketCostToEkuaibao', data)
}

// 市场费用订单列表 getFinanceOrderListByCreatedUserId
export const getFinanceOrderListByCreatedUserId = function (data: {
    financeMarketCostId?: number;
    customerName: string;  // 客户名称
    limit: number;  //条数/页
    page: number; //页码
    source?: string; //2022-09-06 具体来源
    type: string; //2022-11-02 费用类型
}) {
    return axios.post('/finance/getFinanceOrderListByCreatedUserId', data)
}

//新建市场费用
export const setFinanceMarketCost = function (data: {
    types: string;  // 费用类型
    other: string;
    reason: string;
    financeMarketCostDetailList: { financeOrderId: number; priceOrScore: string }[];
    directorUserId: string;
    // financeorderId: string;
    // price: string;
    // score: string;
}) {
    return axios.post('/finance/setFinanceMarketCost', data)
}

// 市场费用详情
export const getFinanceMarketCostById = function (data: {
    id: number;  // id
    isUpdatedData: string;
}) {
    return axios.get('/finance/getFinanceMarketCostById', {params: data})
}

// 编辑市场费用保存
export const setFinanceMarketCostById = function (data: {
    id: number;  // id
    types: string;
    other?: string;
    reason: string;
    financeMarketCostDetailList: { financeOrderId: number; priceOrScore: string }[];
    directorUserId: string;
    // financeOrderId: string;
    // price: string;
    // score: string;
}) {
    return axios.post('/finance/setFinanceMarketCostById', data)
}

// 提交撤销审批费用
export const setFinanceMarketCostStatus = function (data: {
    id: number;
    action: string;  //0-提交, 1-撤销
}) {
    return axios.post('/finance/setFinanceMarketCostStatus', data)
}

// 删除费用
export const delFinanceMarketCostById = function (id: number) {
    return axios.delete('/finance/delFinanceMarketCostById', {data: {id}})
}

// 市场费用导出
export const financeMarketCostExportData = function (data: {
    types: string;  // 费用类型
    keys?: string;
}) {
    return axios.post('/finance/financeMarketCostExportData', data)
}
// 市场费用统计报表
export const financeMarketCostStatisticalData = function (data: {
    limit?: number;
    page?: number;
}) {
    return axios.post('/finance/financeMarketCostStatisticalData', data)
}

// 市场费用统计报表导出
export const financeMarketCostStatisticalDataExport = function (data: {
    customerName: string;  // 	    客户名称
    marketCooperationName: string; // 合作伙伴名称
    status: string;  // 	    状态
    types: string; // 费用类型
    payStatus: string; // 打款状态
    financeOrderCreatedUserIdList: object[];
    souCourseTypeId: number;
    keys?: string;
}) {
    return axios.post('/finance/financeMarketCostStatisticalDataExport', data)
}
// 获取市场费用详情导入模板
export const getFinanceMarketCostDetailTemplate = function () {
    return axios.get('/finance/getFinanceMarketCostDetailTemplate')
}
// 导入开票详情
export const importFinanceMarketCostDetail = function (data: any) {
    return axios.post('/finance/importFinanceMarketCostDetail', data)
}

/*
* 撞单列表*/
export const getFinanceRepeatOrderList = function (data: {
    directorUserIdList: Array<any>;  // 负责人id
    status: string;  // 撞单状态 // '0'-审批中, '1'-已通过, '2'-未通过, '3'-未提交, '4'-已撤回 允许值: '0', '1', '2', '3', '4'
    financeOrderCode: string;  // 订单编号
    code: string;  // 	    撞单编号
    customerType: string;  // 客户类型 // 'customerConversion'-转化客户, 'customerBusiness'-B端客户    允许值: 'customerConversion', 'customerBusiness'
    customerName: string;  // 客户名称
    limit: number;  //条数/页
    page: number; //页码
}) {
    return axios.post('/finance/getFinanceRepeatOrderList', data)
}

/*
* 获取订单列表 （撞单）*/
export const getFinanceOrderListByFinanceRepeatOrder = function (data: {
    source: string; // 具体来源名称
    customerName: string; // 客户名称
    financeRepeatOrderId: number;  //撞单id
    limit: number;  //条数/页
    page: number; //页码
}) {
    return axios.post('/finance/getFinanceOrderListByFinanceRepeatOrder', data)
}


/*
* 新建撞单提交*/
export const setFinanceRepeatOrder = function (data: {
    repeatUserId: string; // 撞单同事
    financeOrderId: string; // 订单id
    explain: number;  //撞单说明（文字）
    financeRepeatOrderExplainList: object;  //撞单说明（图片）
    url: string;  //图片链接
    name: string;  //图片名称
    directorUserId: string;  //负责人id
    customerEduCode: string;  //客户识别号
}) {
    return axios.post('/finance/setFinanceRepeatOrder', data)
}


/*
* 学生列表（撞单）*/
export const getCustomerListByEduCode = function (data: {
    customerEduCode: string;  // 学生识别号
}) {
    return axios.get('/finance/getCustomerListByEduCode', {params: data})
}

/*
* 撤销审批 -- 撞单*/

export const setFinanceRepeatOrderStatus = function (data: {
    id: number;
    action: string;  //0-提交, 1-撤销
}) {
    return axios.post('/finance/setFinanceRepeatOrderStatus', data)
}

/*
* 撞单 -- 详情*/
export const getFinanceRepeatOrderById = function (data: {
    id: number;  // id
    isUpdatedData: string;
}) {
    return axios.get('/finance/getFinanceRepeatOrderById', {params: data})
}

/*
* 编辑 撞单*/
export const setFinanceRepeatOrderById = function (data: {
    id: number;//    撞单id
    repeatUserId: string;//    撞单同事
    financeOrderId: number;//    订单id
    explain: string;//    撞单说明（文字）
    financeRepeatOrderExplainList: object[]; //    撞单说明（图片）
    url: string;//    图片链接
    name: string;//    图片名称
    directorUserId: string;//负责人id
}) {
    return axios.post('/finance/setFinanceRepeatOrderById', data)
}

/*
* 删除 撞单*/

export const delFinanceRepeatOrderById = function (id: number) {
    return axios.delete('/finance/delFinanceRepeatOrderById', {data: {id}})
}

/*
* 撞单 导出*/
export const financeRepeatOrderExportData = function (data: {
    customerName: string;//    客户名称
    customerType: string; //     客户类型 // 'customerConversion'-转化客户, 'customerBusiness'-B端客户     允许值: 'customerConversion', 'customerBusiness'
    code: string; //    撞单编号
    financeOrderCode: string; //     订单编号
    status: string; //      撞单状态 // '0'-审批中, '1'-已通过, '2'-未通过, '3'-未提交, '4'-已撤回     允许值: '0', '1', '2', '3', '4'
    directorUserIdList: string; //负责人id
    keys?: string;
}) {
    return axios.post('/finance/financeRepeatOrderExportData', data)
}

/*
* 撞单统计报表*/
export const financeRepeatOrderStatisticalData = function (data: {
    limit?: number;
    page?: number;
}) {
    return axios.post('/finance/financeRepeatOrderStatisticalData', data)
}

/*
* 撞单统计报表导出*/
export const financeRepeatOrderStatisticalDataExport = function (
    data: {
        limit?: number;
        page?: number;
        keys?: string;
    }
) {
    return axios.get('/finance/financeRepeatOrderStatisticalDataExport', {params: data})
}

/*
* 合同*/

// 获取合同列表
export const getFinanceContractList = function (data: {
    limit: number;  //条数/页
    page: number; //页码
    code: string;
    status: string;
    directorUserIdList: object[];
}) {
    return axios.post('/finance/getFinanceContractList', data)
}


/*
* 新建合同-保存*/
export const setFinanceContract = function (data: {
    mainPart: string;
    signTypes: string;
    sealTypes: string;
    fileTypes: string;
    customerId?: number;
    customerType?: string;
    marketCooperationId?: number;
    contractAt: string;
    remark?: string;
    directorUserId: string;
    fileId: string;
    company: string;
    psnName?: string;
    psnAccount?: string;
}) {
    return axios.post('/finance/setFinanceContract', data)
}

/*合同详情*/
export const getFinanceContractInfoById = function (data: { id: number }) {
    return axios.get('/finance/getFinanceContractById', {params: data})
}

/*编辑合同*/
export const setFinanceContractById = function (data: {
    id: number;
    mainPart: string;
    signTypes: number;
    company: string;
    sealTypes: string;
    fileTypes: string;
    customerId?: number;
    customerType?: number;
    marketCooperationId?: number;
    contractAt: string;
    remark: string;
    directorUserId: string;
    fileId: string;
    url: string;
    psnName?: string;
    psnAccount?: string;
}) {
    return axios.post('/finance/setFinanceContractById', data)
}

/*
* 删除合同*/
export const delFinanceContractById = function (id: number) {
    return axios.delete('/finance/delFinanceContractById', {data: {id}})
}

/*
* 撤回审批*/
export const setFinanceContractStatus = function (data: { id: number; action: string }) {
    return axios.post('/finance/setFinanceContractStatus', data)
}
/*
* eqianbao
* 获取文件上传地址*/
export const eqbUploadFile = function (data: any) {
    return axios.post('/eqianbao/uploadFile', data)
}

/*
* 获取签署链接*/
// export const getSignUrl = function (data: {
//     fileId: string;
//     title: string;
//     psnAccount: string;
// }) {
//     return axios.post('/eqianbao/getSignUrl', data)
// }
/*
* 查询个人认证状态*/
export const getUserInfo = function () {
    return axios.get('/eqianbao/getUserInfo')
}

/*
* 下载合同详情
*/
export const getDownloadFinanceContractById = function (
    data: {
        id: number; // 合同id
    }
) {
    return axios.get('/finance/getDownloadFinanceContractById', {params: data})
}

/*
*查询机构认证状态*/
export const getOrgInfo = function (data: {
    company: string; // 用印公司
}) {
    return axios.get('/eqianbao/getOrgInfo', {params: data})
}

/*合同列表导出*/
export const financeContractExportData = function (data: {
    code: string;
    company: string;
    mainPart: string;
    mainPartName: string;
    fileTypes: string;
    contractStartAt: string;
    contractEndAt: string;// 格式：2022-11-08&2022-11-08
    createdUserIdList: object[];
    status: string;
    types: string;
    signStatus: string;
    directorUserIdList: object[];
    keys?: string;
}) {
    return axios.post('/finance/financeContractExportData', data)
}

/*
* 合同模板*/

/*
* 通过项目类型获取项目价格列表
*/
export const getProjectAllSouCoursePriceList = function (data: {
    souCourseTypeId: string; // 项目类型
}) {
    return axios.get('/finance/getProjectAllSouCoursePriceList', {params: data})
}
/*
* 新建合同模板
*/

export const setFinanceContractTemplate = function (data: {
    detail: string;
    souCourseTypeId: string;
    souCoursePrice: string;
    dissertationType: string;
    companyName: string;
    name: string;
}) {
    return axios.post('/finance/setFinanceContractTemplate', data)
}

/*
* 合同模板列表*/
export const getFinanceContractTemplateList = function (data: {
    souCourseTypeIdList: object[];
    souCoursePrice: string;
    dissertationType: string;
    companyName: string;
    name: string;
    limit: number;
    page: number;
}) {
    return axios.post('/finance/getFinanceContractTemplateList', data)
}

/*
* 合同模板详情*/
export const getFinanceContractTemplateById = function (data: {
    id: string; // 项目类型
}) {
    return axios.get('/finance/getFinanceContractTemplateById', {params: data})
}


/*
* 编辑*/
export const setFinanceContractTemplateById = function (data: {
    id: string;
    detail: string;
    souCourseTypeId: string;
    souCoursePrice: string;
    dissertationType: string;
    companyName: string;
    name: string;
}) {
    return axios.post('/finance/setFinanceContractTemplateById', data)
}

/*
* 删除合同模板*/

export const delFinanceContractTemplateById = function (data: {
    id: string; // 模板id
}) {
    return axios.delete('/finance/delFinanceContractTemplateById', {data})
}


/*
* 新建合同-学生
* 合同中获取订单信息*/

export const getFinancOrder = function (data: {
    customerId: number; // 客户id
    customerType: string; // 客户类型 允许值: 'customerConversion', 'customerBusiness'
    projectAllId: string; // 项目id
}) {
    return axios.post('/finance/getFinancOrder', data)
}

/*
* 获取合同模板*/
export const getFinanceContractTemplate = function (data: {
    dissertationType: string; // 论文服务类型
    souCoursePrice: string; // 项目价格
    souCourseTypeId: number; // 项目类型
    companyName: string; // 所属公司
}) {
    return axios.post('/finance/getFinanceContractTemplate', data)
}


/*
* 生成合同pdf*/
export const generatePdf = function (data: {
    htmlStr: string;
    marginTop: number;
    marginBottom: number;
    sealName?: string;
}) {
    return axios.post('/pdf/generate/generatePdf', data)
}


/*
* 编辑合同--类型为学生*/
export const setFinanceContractByIdAndTypes = function (data: {
    id: number;
    directorUserId: string;
    isAdult: string;
    custodianName?: string;
    custodianPhone?: string;
    custodianIdCard?: string;
    psnAccount: string;
    idCard: string;
    contractAt: string;
}) {
    return axios.post('/finance/setFinanceContractByIdAndTypes', data)
}


/*
* 合同----上传签署完成合同
*finance/updFinanceContractById*/
export const updFinanceContractById = function (data: {
    id: number;
    url: string;
}) {
    return axios.post('/finance/updFinanceContractById', data)
}


/*/finance/accountsReceivableStatisticalReport
应收账款统计报表*/

export const getAccountsReceivableStatisticalReport = function (
    data: {
        directorUserIdList: object[];
        departmentIdList: object[];
        souCourseSchoolBegin: string;
        createdAt: string;
        limit: number;
        page: number;
    }) {
    return axios.post('/finance/accountsReceivableStatisticalReport', data)
}
/*
* /finance/accountsReceivableDetailStatisticalReport
*/
export const getAccountsReceivableDetailStatisticalReport = function (
    data: {
        marketCooperationName: string;
        directorUserIdList: object[];
        departmentIdList: object[];
        souCourseSchoolBegin: string;
        createdAt: string;
        limit: number;
        page: number;
    }) {
    return axios.post('/finance/accountsReceivableDetailStatisticalReport', data)
}


/*销售排名报表
* /finance/salesRankingReport*/
export const getSalesRankingReport = function (
    data: {
        createdUserIdList: object[];
        departmentIdList: object[];
        createdAt: string;
        limit: number;
        page: number;
    }) {
    return axios.post('/finance/salesRankingReport', data)
}